import { FlaskConical, ScrollText } from "lucide-react";
import { useDemo } from "../context/DemoContext";
import { useAuth } from "../context/AuthContext";
import { HistoryReal } from "../real/RealScreens";
import { formatDateBR, formatDateTimeBR } from "@tracker-bet-analystic/domain";
import { EmptyState } from "../components/EmptyState";

export function History() {
  const { analyses, isDemo } = useDemo();
  const { configured } = useAuth();

  if (configured && !isDemo) {
    return <HistoryReal />;
  }

  return (
    <div>
      <header className="mb-6">
        <h1 className="text-2xl font-bold text-[var(--color-text)]">Histórico de Análises</h1>
      </header>

      {analyses.length > 0 ? (
        <div className="card overflow-hidden">
          <div className="table-container">
            <table className="table" role="table">
              <thead>
                <tr>
                  <th scope="col">Data da Análise</th>
                  <th scope="col">Partida</th>
                  <th scope="col">Competição</th>
                  <th scope="col">Data do Jogo</th>
                  <th scope="col">Motor</th>
                  <th scope="col">Status</th>
                  <th scope="col">Ação</th>
                </tr>
              </thead>
              <tbody>
                {analyses.map((analysis) => (
                  <tr key={analysis.fixture.id}>
                    <td>{formatDateTimeBR(analysis.generatedAt)}</td>
                    <td className="font-medium">
                      {analysis.fixture.homeTeamName} vs {analysis.fixture.awayTeamName}
                    </td>
                    <td>{analysis.fixture.competitionName}</td>
                    <td>{formatDateBR(analysis.fixture.kickoffAt)}</td>
                    <td>
                      <span className="badge badge-neutral">{analysis.engineVersion}</span>
                    </td>
                    <td>
                      <span className={`badge ${analysis.model ? "badge-success" : "badge-warning"}`}>
                        {analysis.model ? "Com modelo" : "Apenas descritivo"}
                      </span>
                    </td>
                    <td>
                      <a
                        href={`/report/${analysis.fixture.id}`}
                        className="btn btn-sm btn-primary"
                      >
                        Ver Snapshot
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <EmptyState
          icon={<ScrollText />}
          title="Histórico vazio"
          text="Suas análises aparecerão aqui. Crie a primeira análise na busca."
          action={<a href="/search" className="btn btn-primary mt-4">Criar primeira análise</a>}
        />
      )}

      <div className="mt-8 p-4 bg-[var(--color-bg)] border border-[var(--color-border)] rounded-lg">
        <h3 className="font-semibold mb-2">Sobre o histórico</h3>
        <ul className="text-sm text-[var(--color-text-muted)] space-y-1">
          <li>• Cada linha abre o snapshot imutável da análise no momento da geração</li>
          <li>• Atualizações de odds criam uma nova revisão (nova linha), não sobrescrevem o histórico</li>
          <li>• Conversas ficam vinculadas à análise original</li>
          <li>• Dados demo são identificados com badge "Dados sintéticos"</li>
        </ul>
      </div>

      {isDemo && (
        <div className="mt-4 p-4 bg-[var(--color-demo-light)] border border-[var(--color-demo)] rounded-lg">
          <p className="text-sm text-[var(--color-demo)]">
            <FlaskConical size={14} aria-hidden="true" /> <strong>Modo Demonstração:</strong> O histórico é armazenado apenas na sessão atual (memória).
            Recarregar a página limpa o histórico demo.
          </p>
        </div>
      )}
    </div>
  );
}
